import {Component, forwardRef, Injector, Input, ViewChild} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";
import {FormGroup} from "@angular/forms";
import {FUITimeControlComponent} from "@fedeltapointofsale/ui";
import {EntityData} from "@fedeltapointofsale/data-client";

/**
 * Search grid column to render Time values
 */
@Component({
    selector: "wbo-time-column",
    styleUrls: ["./time-column.component.scss"],
    templateUrl: "./time-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => TimeColumnComponent), multi: true}
    ]
})
export class TimeColumnComponent extends AbstractColumnComponent {
    @Input() pattern: string;
    @Input() defaultValue: string;
    @Input() cellClassGetter: (this: void, formGroup: FormGroup, dataItem: any) => any;
    @ViewChild("editControl") editControl: FUITimeControlComponent;

    constructor(injector: Injector) {
        super(injector);
    }

    valueChanged(value: any, dataItem: any, formGroup: FormGroup, fieldName?: string): void {
        if (value == undefined && this.defaultValue) {
            this.editControl.value = EntityData.parseTime(this.defaultValue, this.pattern);
        } else {
            this.emitValueChange(value, dataItem, formGroup, fieldName, this.editControl);
        }
    }
}
